module.exports = __webpack_public_path__ + "static/img/bg-mobile.fa46f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-manager/img/bg-mobile.png
// module id = HchV
// module chunks = 46